





































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import OperatingSystemSelector from '@/components/new-virtual-machine/OperatingSystemSelector.vue';
import KeysConfigurationDialog from '@/components/new-virtual-machine/KeysConfigurationDialog.vue';
import { newVirtualMachineService } from '@/components/new-virtual-machine/services/NewVirtualMachineService';
import ClusterParametersSelector from '@/components/new-virtual-machine/ClusterParametersSelector.vue';
import NewVirtualMachineSummary from '@/components/new-virtual-machine/NewVirtualMachineSummary.vue';
import Menu from '@/components/common/Menu.vue';
import { NewVirtualMachineData } from '@/interfaces/NewVirtualMachineData';
import { OperatingSystem } from '@/interfaces/OperatingSystem';
import { PrivateNetworkData } from '@/interfaces/PrivateNetworkData';
import { SshKey } from '@/interfaces/SshKey';
import { OperatingSystemVersion } from '@/interfaces/OperatingSystemVersion';

@Component({
  components: {
    ClusterParametersSelector,
    OperatingSystemSelector,
    KeysConfigurationDialog,
    NewVirtualMachineSummary,
    Menu,
  },
})
export default class NewVirtualMachineForm extends Vue {
  isModalShown = false;
  diskTypes: any = [];
  operatingSystems: OperatingSystem[] = [];
  privateNetworks: PrivateNetworkData[] = [];
  selectedKeys: SshKey[] = [];
  params = null;
  selectedAuth = '1';
  keysCount = 0;
  configuration: any = {
    name: 'Virtual_Machine',
    params: {
      rest: {},
    },
    system: null,
    version: null,
    network: null,
    auth: null,
    authType: 'pass',
    ip: false,
    ipPrice: { cents: 0 },
    keys: [],
  };
  workspaceId = 0;
  regionId = 0;
  isMachineNameEmpty = false;
  isNetworkEmpty = false;
  isWinAgreementEmpty = false;
  accessAgreement = false;

  @Watch('selectedAuth')
  onAuthChange(val: string) {
    this.configuration.auth = val === '1' ? this.$t('password') : this.$t('SSHKeys');
    this.configuration.authType = val === '1' ? 'pass' : 'ssh';
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.configuration.auth = this.$t('password');
    newVirtualMachineService
      .getNewVirtualMachineData(this.workspaceId, this.regionId)
      .then((data: NewVirtualMachineData) => {
        this.diskTypes = data.disk_types;
        this.operatingSystems = data.operating_systems;
        this.privateNetworks = data.private_networks.filter((el: any) => el.state === 'idle');
        this.configuration.ipPrice = data.public_ip_price;
        this.configuration.network = this.privateNetworks[0];
      });
  }

  setKeys(keys: SshKey[]) {
    if (!keys) {
      this.selectedAuth = '1';
    }
    this.keysCount = keys.length;
    this.selectedKeys = keys;
    this.configuration.keys = keys;
  }

  setParameters(params: any) {
    this.params = params;
    this.configuration.params = params;
  }

  selectOS(system: OperatingSystem) {
    this.configuration.system = system;
  }

  selectVersion(version: OperatingSystemVersion) {
    this.configuration.version = version;
  }
}
